import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  background: #000000b3;
  z-index: 50;
  transition: visibility 500ms, opacity 500ms, display 500ms;
  &.hide {
    opacity: 0;
    visibility: hidden;
  }

  &.show {
    opacity: 1;
    visibility: visible;
    transform: scale(1);
  }

  .popup {
    width: 70vw;
    height: 50vh;
    background: #fff;
    margin: 25vh calc(15vw - 3rem);
    padding: 0 3rem;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    position: relative;
    .bold {
      font-weight: 700;
    }
    .closePopup {
      position: absolute;
      top: 10px;
      right: 10px;
    }
    h2 {
      margin-top: 0;
    }
    .email-input-container {
      display: flex;
      justify-content: space-between;
      width: 100%;
      input {
        height: 30px;
        width: 100%;
        border-radius: 5px 0 0 5px;
        border: 1px solid #d1d3d6;
        padding: 0;
      }
      button {
        height: 30px;
        width: 40%;
        border-radius: 0 5px 5px 0;
        margin: 0;
      }
    }
  }
  .emails-list {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 6px;
    margin-top: 8px;
    max-height: 120px;
    overflow: scroll;
  }

  .email-chip {
    background: #f3f3f3;
    border-radius: 16px;
    padding: 4px 10px;
    cursor: pointer;
    transition: background 0.2s;
  }

  .email-chip:hover {
    background: #e0e0e0;
  }
  @media only screen and (min-width: 867px) {
    .popup {
      width: 40vw;
      margin: 25vh calc(30vw - 3rem);
      .email-input-container input {
        width: 60%;
      }
    }
  }
`;

export const SuggestionsListContainer = styled.div`
  ul {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: white;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    z-index: 100;
    margin-top: 4px;
    list-style: none;
    padding: 4px 0;

    li {
      padding: 0.5rem;
      cursor: pointer;

      &:hover {
        background: lightgray;
      }
    }
  }
`;
